import { AdvertEntity } from '../../domain/entities/Advert';
import { AdvertTitle } from '../../domain/value-objects/AdvertTitle';
import { IAdvertRepository, CreateAdvertDTO } from '../ports/IAdvertRepository';

export interface CreateAdvertInput { title: string; description: string; attachments: { file: File | Blob; mimeType: string; }[]; }

export class CreateAdvertUseCase {
  constructor(private repo: IAdvertRepository) {}
  async execute(input: CreateAdvertInput): Promise<AdvertEntity> {
    const title = AdvertTitle.create(input.title);
    const extFromMime = (mt: string) => {
      if (!mt) return '';
      const map: Record<string,string> = { 'image/jpeg': 'jpg', 'image/jpg': 'jpg', 'image/png': 'png', 'image/webp': 'webp', 'image/gif': 'gif', 'video/mp4': 'mp4', 'video/quicktime': 'mov' };
      return map[mt] ? `.${map[mt]}` : '';
    };
    const dto: CreateAdvertDTO = {
      title: title.Value,
      description: input.description,
      attachments: input.attachments.map((a,i)=> {
        const name = (a.file as any)?.name || `attachment_${i}${extFromMime(a.mimeType)}`;
        return { fileName: name, mimeType: a.mimeType, data: a.file, position: i };
      })
    };
    return this.repo.create(dto);
  }
}
